import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { formatDistanceToNow, format } from 'date-fns';
import { getUpdates } from '../api/client';

const sentimentEmoji: Record<string, string> = {
  positive: '🟢',
  neutral: '🟡',
  negative: '🔴',
};

export default function Updates() {
  const [days, setDays] = useState(7);
  const { data: updates, isLoading } = useQuery({
    queryKey: ['updates', days],
    queryFn: () => getUpdates(days),
  });

  return (
    <div>
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Updates</h1>
          <p className="text-gray-500 mt-1">All customer updates</p>
        </div>

        <select
          value={days}
          onChange={(e) => setDays(Number(e.target.value))}
          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500"
        >
          <option value={7}>Last 7 days</option>
          <option value={14}>Last 14 days</option>
          <option value={30}>Last 30 days</option>
          <option value={90}>Last 90 days</option>
        </select>
      </div>

      {isLoading ? (
        <div className="text-center py-12 text-gray-500">Loading...</div>
      ) : updates?.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          No updates found for this period
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100">
          <div className="divide-y divide-gray-100">
            {updates?.map((update) => (
              <div key={update.id} className="p-6">
                <div className="flex items-start gap-4">
                  <span className="text-2xl">
                    {sentimentEmoji[update.sentiment || 'neutral']}
                  </span>
                  <div className="flex-1">
                    <p className="text-gray-700">
                      {highlightHashtags(update.raw_text)}
                    </p>
                    <p className="text-sm text-gray-400 mt-2">
                      {format(new Date(update.created_at), 'MMM d, yyyy h:mm a')} •{' '}
                      {formatDistanceToNow(new Date(update.created_at), { addSuffix: true })}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function highlightHashtags(text: string): React.ReactNode {
  const parts = text.split(/(#\w+[-\w]*)/g);
  return parts.map((part, i) =>
    part.startsWith('#') ? (
      <span key={i} className="text-primary-600 font-medium">{part}</span>
    ) : (
      part
    )
  );
}
